/* eslint-disable @typescript-eslint/ban-ts-comment */
import {AxiosResponse} from "axios";
import {Filter} from "@mm-products/java-multima-framework";
import {taxGuruAxios} from "../axios";
import {taxAccountantUrls} from "../url";
import {TaxAccountantDto} from "../models/TaxAccountantDto";
import {TaxAccountantResult} from "../models/TaxAccountantResult";
import {TaxAccountantWizardDto} from "../models/TaxAccountantWizardDto";
import {TaxAccountantRequest} from "../models/TaxAccountantRequest";

export const listAccountants = (
    filter: Filter,
    signal?: AbortSignal,
    toastId?: string,
    noErrorToast?: boolean
): Promise<AxiosResponse<TaxAccountantResult>> => {
    return taxGuruAxios.post(taxAccountantUrls.filter, filter, {
        signal,
        // @ts-ignore
        toastId,
        // @ts-ignore
        noErrorToast,
    });
};

export const createAccountant = (taxAccountant: TaxAccountantDto, toastId?: string): Promise<AxiosResponse<TaxAccountantDto>> => {
    return taxGuruAxios.post(taxAccountantUrls.create, taxAccountant, {
        // @ts-ignore
        toastId,
    });
};

export const createAccountantByWizard = (taxAccountant: TaxAccountantWizardDto, toastId?: string): Promise<AxiosResponse<TaxAccountantDto>> => {
    return taxGuruAxios.post(taxAccountantUrls.createByWizard, taxAccountant, {
        // @ts-ignore
        toastId,
    });
};

export const deleteAccountant = (taxAccountantId: string, toastId?: string): Promise<TaxAccountantDto> => {
    return taxGuruAxios.delete(taxAccountantUrls.delete(encodeURIComponent(taxAccountantId)), {
        // @ts-ignore
        toastId,
    }).then(({data}) => data);
};

export const updateAccountant = (
    taxAccountantId: string,
    taxAccountant: TaxAccountantRequest,
    toastId?: string
): Promise<TaxAccountantDto> => {
    return taxGuruAxios.put(taxAccountantUrls.update(encodeURIComponent(taxAccountantId)), taxAccountant, {
        // @ts-ignore
        toastId,
    }).then((res) => res.data);
};

export const getAccountant = (taxAccountantId: string, toastId?: string, signal?: AbortSignal, noErrorToast?: boolean): Promise<TaxAccountantDto> => {
    return taxGuruAxios
        .get(taxAccountantUrls.get(encodeURIComponent(taxAccountantId)), {
            // @ts-ignore
            toastId,
            signal,
            noErrorToast,
        })
        .then((res) => res.data);
};
